// eslint-disable-next-line no-restricted-imports
import { LegalClientOpenAccountOrderFragment } from 'api/generated/graphql';
import { parseFileDocumentEntity } from 'api/helpers/client/parseEntity/parseFileEntity';
import { LegalClientOpenAccountOrderEntity } from 'api/types/entity';

export const parseLegalClientOpenAccountOrderEntity = (
  openAccountOrder: LegalClientOpenAccountOrderFragment | undefined | null
): LegalClientOpenAccountOrderEntity => ({
  date: openAccountOrder?.date ? new Date(openAccountOrder?.date) : undefined,
  number: openAccountOrder?.number,
  orderReceivedDate: openAccountOrder?.orderReceivedDate
    ? new Date(openAccountOrder?.orderReceivedDate)
    : undefined,
  document: openAccountOrder?.document
    ? parseFileDocumentEntity(openAccountOrder?.document)
    : undefined,
});
